$(function () {
  if (!customElements.get('member-banner')) {
    customElements.define(
      'member-banner',
      class memberBanner extends HTMLElement {
        constructor() {
          super();
          window.litime.ModalControllerState = window.litime.ModalControllerState || new ModalController();
          this.modalManager = window.litime.ModalControllerState;
          this.activityContainer = null;
          this.rewardsContainer = null;
          this.firstOpen = true;
          this.memberBannerRewardsTabs = null;
          this.code = null;
          this.token =
            'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOjkwMDAwMTY4MywiYWNjZXNzIjoiYWNjZXNzIiwiZXhwIjoxOTAwODA4NTgyfQ.6hdmN-fLW-pOBoQQsGn1DO2JmV8odkekYh2_aH4Rwak';
        }
        async connectedCallback() {
          this.initModal();
          this.init();
          const ltHeader = $(document.querySelector('#lt-header'));
          ltHeader.data('screen', 'true');
          window.litime.eventBus.subscribe('CHANGE_USER_POINTS_DATA', (res) => {
            this.updateUserPoints(res);
            window.litime.eventBus.publish('RENDER_REDEEM_LIST', res.currentPoint);
          });
          if (window.customer) {
            const avatarContainer = $(this.querySelector('.avatar-container'));
            const ltUserInfo = window.litime.getLocalStorage('ltUserInfo');
            if (ltUserInfo?.avatarLink) {
              avatarContainer.find('.user-info-email').addClass('hidden');
              avatarContainer.find('.user-info-email-img').removeClass('hidden');
              avatarContainer.find('.user-info-email-img').attr('src', ltUserInfo.avatarLink);
            }
            this.getMemberPoints()
              .then((res) => {
                this.updateUserPoints(res);
                window.litime.eventBus.publish('RENDER_REDEEM_LIST', res.currentPoint);
              })
              .catch((error) => {
                if (window.litime?.showToast) {
                  window.litime.showToast('error', window.i18n.request_failed);
                }
              });
          }
          const memberRedeemModalClose = this.querySelector('.member-redeem-modal-close');
          memberRedeemModalClose.addEventListener('click', () => {
            this.closeModal();
          });
          const memberRedeemModalBtnCopy = $(this.querySelector('.member-redeem-modal-btn-copy')).find('button');
          memberRedeemModalBtnCopy.on('click', () => {
            this.copy();
          });

          const memberBannerLoginBtn = $(this.querySelector('.member-banner-login-btn'));
          memberBannerLoginBtn.on('click', () => {
            window.litime.eventBus.publish('LOGIN');
          });
          const memberBannerRegisterBtn = $(this.querySelector('.member-banner-register-btn'));
          memberBannerRegisterBtn.on('click', () => {
            window.litime.eventBus.publish('REGISTER');
          });
        }

        updateUserPoints(res) {
          try {
            window.litime.userPointData = JSON.parse(JSON.stringify(res));
            const memberInfo = $(this.querySelector('.member-banner__user-info'));
            memberInfo.removeClass('hidden').addClass('flex');
            // 获取member-tier
            const memberTier = $('.member-tier');
            // 获取member-point
            const memberPoint = $('.member-point');
            // 获取member-need-points
            const memberNeedPoints = $('.member-need-points');
            memberTier.text(res.settingName || '--');
            memberPoint.text(res.currentPoint);

            if (res.nextSettingValue && res.nextSettingName) {
              if (memberNeedPoints.find('span').length > 0) {
                if (res.settingType === 2) {
                  memberNeedPoints.find('.nextSettingName').text(res.nextSettingName);
                  memberNeedPoints.find('.upgradePoints').text(res.nextSettingValue - res.currentPoint);
                } else {
                  memberNeedPoints.find('.nextSettingName').text(res.nextSettingName);
                  memberNeedPoints
                    .find('.upgradePoints')
                    .text(Math.floor(res.nextSettingValue - Math.floor(res.totalAmount)));
                }
              } else {
                if (res.settingType === 2) {
                  // 获取memberNeedPoints文本
                  const memberNeedPointsText = memberNeedPoints.text();
                  memberNeedPoints.html(
                    memberNeedPointsText
                      .replace('{{ tier }}', `<span class="text-primary nextSettingName">${res.nextSettingName}</span>`)
                      .replace(
                        '{{ points }}',
                        `<span class="text-primary upgradePoints">${res.nextSettingValue - res.currentPoint}</span>`
                      )
                  );
                } else {
                  const memberNeedPointsText = memberNeedPoints.attr('data-max-points');
                  memberNeedPoints.html(
                    memberNeedPointsText
                      .replace(
                        '{{ dollar }}',
                        `<span class="text-primary upgradePoints">${Math.floor(
                          res.nextSettingValue - Math.floor(res.totalAmount)
                        )}</span>`
                      )
                      .replace(
                        '{{ level }}',
                        `<span class="text-primary nextSettingName">${res.nextSettingName}</span>`
                      )
                  );
                }
              }
              const memberPointCurrent = $('.member-point-current');
              const memberPointTotal = $('.member-point-total');
              if (res.settingType === 2) {
                memberPointCurrent.text(res.currentPoint);
                memberPointTotal.text(res.nextSettingValue);
              } else {
                memberPointCurrent.text(Math.floor(res.totalAmount));
                memberPointTotal.text(res.nextSettingValue);
              }
              // 获取member-progress
              const memberProgress = $('.member-progress');
              if (res.settingType === 2) {
                memberProgress.css('--progress', `${Math.min(100, (res.currentPoint / res.nextSettingValue) * 100)}%`);
              } else {
                memberProgress.css('--progress', `${Math.min(100, (res.totalAmount / res.nextSettingValue) * 100)}%`);
              }
            } else {
              $('.member-banner_max_level_wrapper').removeClass('hidden');
              const maxLevelText = $('.member-banner_max_level_wrapper').text();
              $('.member-banner_points_wrapper').addClass('hidden');
              $('.member-banner_max_level_wrapper').html(maxLevelText.replace('{{ level }}', res.settingName));
            }

            const memberLevelTableWrapper = document.querySelector('.member-level_table_wrapper');
            const memberLevel = document.querySelector('.member-level');
            memberLevel.querySelectorAll(`[data-memberSettingId="${res.settingId}"]`).forEach((item) => {
              item.classList.add('user-benefit_active');
              // 获取item 距离memberLevelTableWrapper的距离
              let diff = 0;
              if (window.innerWidth > 576) {
                diff = 320;
              } else {
                diff = 150;
              }
              const itemOffset = item.offsetLeft - diff;
              memberLevelTableWrapper.scrollLeft = itemOffset;
            });
          } catch (error) {
            console.log(error);
          }
        }

        copy() {
          window.litime.copyToClipboard(this.code);
          // 跳转到首页
          const redirecturl = `/discount/${this.code}`;
          window.location.href = redirecturl;
        }

        // 获取会员积分信息
        async getMemberPoints() {
          const url = '/shopify/user/point';
          const { data, code } = await window.litime.http.get(url);
          if (code === 200) {
            return data;
          } else {
            return null;
            // throw new Error(window.i18n.error_message_timeout);
          }
        }

        // 获取会员奖励列表
        async getMemberRewards(data) {
          const url = '/shopify/user/page/discount';
          const res = await window.litime.http.get(url, {
            data,
          });
          if (res.code === 200) {
            return res.data;
          } else {
            throw new Error(window.i18n.error_message_timeout);
          }
        }

        // 获取会员日志
        async getMemberLogs() {
          const url = '/shopify/user/pointLog';
          const res = await window.litime.http.get(url);
          if (res.code === 200) {
            return res.data;
          } else {
            throw new Error(window.i18n.error_message_timeout);
          }
        }

        showButtonLoading(button) {
          button.attr('data-show-loading', 'true');
        }

        hideButtonLoading(button) {
          button.attr('data-show-loading', 'false');
        }

        init() {
          const _this = this;
          const rewardBtn = this.querySelector('.reward-btn');
          const activityBtn = this.querySelector('.activity-btn');

          this.rewardsContainer = this.modalManager.getModal('member_banner_rewards_modal');

          rewardBtn?.addEventListener('click', async () => {
            try {
              this.showButtonLoading($(rewardBtn).find('button'));
              const res = await this.getMemberRewards({
                page: 1,
                pageSize: 999,
                status: 0,
              });
              this.memberBannerRewardsTabs = 'available';
              const dataRewardTab = $(this.rewardsContainer.querySelectorAll('[data-reward-tab]'));
              dataRewardTab.removeClass('active-tab');
              dataRewardTab.eq(0).addClass('active-tab');

              this.renderRewardsContent('available', res);
              this.modalManager.open('member_banner_rewards_modal');
              this.hideButtonLoading($(rewardBtn).find('button'));
            } catch (error) {
              this.hideButtonLoading($(rewardBtn).find('button'));
              window.litime.showToast('error', window.i18n.request_failed);
            }
          });
          activityBtn?.addEventListener('click', async () => {
            this.showButtonLoading($(activityBtn).find('button'));
            try {
              const res = await this.getMemberLogs();
              this.activityContainer = this.modalManager.getModal('activity-modal');
              setTimeout(() => {
                if (!res || res.length === 0) {
                  $(this.activityContainer.querySelector('.table-container')).addClass('hidden');
                  $(this.activityContainer.querySelector('.member-activity_empty'))
                    .removeClass('hidden')
                    .addClass('flex');
                } else {
                  $(this.activityContainer.querySelector('.table-container')).removeClass('hidden');
                  $(this.activityContainer.querySelector('.member-activity_empty')).addClass('hidden');
                  const tbody = this.activityContainer.querySelector('tbody');
                  $(tbody).empty();
                  res.forEach((item) => {
                    this.addTableRow(item.businessName, item.pointDesc, item.createdTime, item.isLimit);
                  });
                }
                this.modalManager.open('activity-modal');
                this.hideButtonLoading($(activityBtn).find('button'));
              }, 100);
            } catch (error) {
              this.hideButtonLoading($(activityBtn).find('button'));
              window.litime.showToast('error', window.i18n.request_failed);
            }
          });
        }

        // 添加数据示例
        addTableRow(action, points, date, isLimit) {
          const tbody = this.activityContainer.querySelector('tbody');
          const tr = document.createElement('tr');
          let pointNumber = 0;
          if (!isLimit) {
            pointNumber = parseInt(points.match(/-?\d+/)[0]);
          }
          const userDate = this.switchTimeZone(date);
          tr.innerHTML = `
            <td>${action}</td>
            ${
              isLimit
                ? `<td class="points-negative">${points}</td>`
                : `
              <td class="${pointNumber > 0 ? 'points-positive' : 'points-negative'}">
                ${points}
            </td>`
            }
           
            <td>${userDate.toLocaleString()}</td>
            `;

          tbody.append(tr);
        }

        showLoading() {
          const ContentList = $(this.rewardsContainer.querySelectorAll(`[data-reward-tab-content]`));
          ContentList.addClass('hidden');
          $(this.rewardsContainer.querySelector('.member-redeem_empty')).addClass('hidden');
          const memberRedeemLoading = $(this.rewardsContainer.querySelector('.member-redeem_reward_loading'));
          memberRedeemLoading.removeClass('hidden').addClass('flex');
        }

        hideLoading() {
          const memberRedeemLoading = $(this.rewardsContainer.querySelector('.member-redeem_reward_loading'));
          memberRedeemLoading.addClass('hidden').removeClass('flex');
        }

        initModal() {
          if (!this.modalManager.getModal('activity-modal')) {
            this.modalManager.register('activity-modal', {
              onOpen: (container) => {
                this.activityContainer = container;
              },
              onClose: () => {},
            });
          }
          if (!this.modalManager.getModal('member_banner_rewards_modal')) {
            this.modalManager.register('member_banner_rewards_modal', {
              onOpen: (container) => {
                if (!this.firstOpen) return;
                const _this = this;
                this.rewardsContainer = container;
                this.firstOpen = false;
                const memberBannerRewardsTab = $(this.rewardsContainer.querySelectorAll('[data-reward-tab]'));
                memberBannerRewardsTab.on('click', async function () {
                  const memberBannerRewardsTabContent = $(
                    _this.rewardsContainer.querySelector('.member_banner_rewards_modal_content')
                  );
                  const target = $(this);
                  const tab = target.data('reward-tab');
                  if (tab != _this.memberBannerRewardsTabs) {
                    memberBannerRewardsTab.removeClass('active-tab');
                    target.addClass('active-tab');
                    _this.showLoading();
                    try {
                      const res = await _this.getMemberRewards({
                        page: 1,
                        pageSize: 999,
                        status: tab === 'available' ? 0 : tab === 'used' ? 1 : 2,
                      });
                      _this.memberBannerRewardsTabs = tab;
                      _this.hideLoading();
                      _this.renderRewardsContent(tab, res);
                      // memberBannerRewardsTabContent回到顶部
                      memberBannerRewardsTabContent.scrollTop(0);
                    } catch (error) {
                      _this.hideLoading();
                      window.litime.showToast('error', error.message);
                    }
                  }
                });
              },
              onClose: () => {},
            });
          }
        }

        closeModal() {
          const memberRedeemModal = $(this.querySelector('.member-redeem-modal'));
          memberRedeemModal.addClass('hidden').removeClass('flex');
        }

        handleScroll() {
          const memberRedeemScrollContainer = this.querySelector('.member-redeem-scroll-container');
          const memberRedeemModalBtnRedeemWrapper = this.querySelector('.member-redeem-modal-btn-redeem_wrapper');
          const memberRedeemModalBtn = this.querySelector('.member-redeem-modal-btn');
          if (
            memberRedeemScrollContainer.scrollTop + memberRedeemScrollContainer.clientHeight >=
            memberRedeemScrollContainer.scrollHeight
          ) {
            memberRedeemModalBtnRedeemWrapper.classList.add('border-t');
            memberRedeemModalBtn.style.boxShadow = 'none';
          } else {
            memberRedeemModalBtnRedeemWrapper.classList.remove('border-t');
            memberRedeemModalBtn.style.boxShadow = '0 0 4px 0px #0000001a';
          }
        }

        // 根据奖励券渲染内容
        async renderRewardsContent(tab, data) {
          if (!data) {
            return;
          }
          const ContentList = $(this.rewardsContainer.querySelectorAll(`[data-reward-tab-content]`));
          ContentList.addClass('hidden');
          if (data.records.length === 0) {
            $(this.rewardsContainer.querySelector('.member-redeem_empty')).removeClass('hidden').addClass('flex');
            return;
          } else {
            $(this.rewardsContainer.querySelector('.member-redeem_empty')).addClass('hidden');
          }
          const ContentHtml = $(this.rewardsContainer.querySelector(`[data-reward-tab-content="${tab}"]`));
          ContentHtml.removeClass('hidden');
          const rewardsListWrapper = ContentHtml.find('.rewards-list_wrapper');
          // 复制第一个奖励券
          const copyRewardItem = rewardsListWrapper.find('.reward-item').first().clone();
          // 移除所有奖励券
          rewardsListWrapper.empty();
          data.records.forEach((item) => {
            const rewardItem = copyRewardItem.clone();
            const img = rewardItem.find('.member-redeem-img');
            if (item.icon) {
              img.attr('src', item.icon);
              img.attr('alt', item.rewardName);
            }
            img.on('click', () => {
              this.code = item.discountCode;
              const memberRedeemModal = $(this.querySelector('.member-redeem-modal'));
              memberRedeemModal.find('.member-redeem-modal-title').text(item.rewardName);
              memberRedeemModal.find('.member-redeem-modal-points').addClass('hidden');
              memberRedeemModal
                .find('.member-redeem-modal-code')
                .removeClass('hidden')
                .find('span')
                .text(item.discountCode);
              if (item.icon) {
                memberRedeemModal.find('.member-redeem-modal-img').attr('src', item.icon);
              }
              if (window.innerWidth > 576) {
                memberRedeemModal.find('.member-redeem-rules').html(item.rule).css('padding-bottom', '80px');
              } else {
                memberRedeemModal.find('.member-redeem-rules').html(item.rule).css('padding-bottom', '64px');
              }
              memberRedeemModal.find('.member-redeem-modal-btn').removeClass('hidden').addClass('flex');
              memberRedeemModal.find('.member-redeem-modal-btn-redeem_wrapper').addClass('hidden');
              memberRedeemModal.find('.member-redeem-modal-btn-copy').removeClass('hidden').addClass('flex');
              memberRedeemModal.removeClass('hidden').addClass('flex');
              if (this.memberBannerRewardsTabs != 'available') {
                memberRedeemModal.find('.member-redeem-modal-btn-copy').addClass('hidden');
                memberRedeemModal.find('.member-redeem-rules').html(item.rule).css('padding-bottom', '16px');
              } else {
                this.handleScroll();
              }
            });
            const title = rewardItem.find('.member-redeem-title');
            title.text(item.rewardName);
            const code = rewardItem.find('.member-redeem-code').find('span');
            code.text(item.discountCode);
            const i = rewardItem.find('.member-redeem-code').find('i');
            i.on('click', () => {
              window.litime.copyToClipboard(item.discountCode);
            });
            if (item.expiredAt) {
              const expiresOn = rewardItem.find('.member-redeem-date');
              // 将item.expiredAt转换为用户当前时区时间
              const localTime = this.switchTimeZone(item.expiredAt);
              expiresOn.text(window.i18n.member_expires_on.replace('{date}', `${localTime.toLocaleDateString()}`));
            } else {
              rewardItem.find('.member-redeem-date').text(window.i18n.member_no_expiration_date);
            }
            rewardsListWrapper.append(rewardItem);
          });
        }

        // 切换时区时间
        switchTimeZone(cnTime) {
          // 创建北京时间对象
          const cnDate = new Date(cnTime);

          // 获取用户时区偏移（分钟）
          const userOffset = new Date().getTimezoneOffset();

          // 将用户偏移转换为小时（注意：getTimezoneOffset 返回的是负值）
          const userOffsetHours = -userOffset / 60;

          // 计算时差（小时）
          const diffHours = 8 - userOffsetHours;

          // 转换为用户本地时间
          return new Date(cnDate.getTime() - diffHours * 60 * 60 * 1000);
        }
      }
    );
  }
});
